import React, {useCallback, useEffect, useRef, useState} from 'react';
import {connect, useSelector, useDispatch} from 'react-redux';
import {
  registerUser,
  verifyOTP,
  registerUserModalClose,
  registerUserInterim,
  verifyUserInterim,
  setFirstLogin,
} from './redux/login.action';
import {
  getConfig,
  setIsLogin,
  setLoginVisibility,
} from '../../utils/commonredux/commonRedux.action';
import {
  getUser,
  getUserProfile,
  setProfileEmpty,
} from '../Profile/redux/profile.action';
import MobileLogin from './childComponents/MobileLogin';
import VerifyOtp from './childComponents/VerifyOtp';
import ConsentForm from './childComponents/ConsentForms';
import LoginHeader from './childComponents/LoginHeader';
import {Network} from '../../utils/network';
import {headerSet} from '../../utils/networkFetch';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {ScrollView, View} from 'react-native';
import {fetchLivePorfolio} from '../portfolio/redux/portfolio.action';
import {useToast} from '../../components/core/Toast';
import {
  hideLoader,
  showLoader,
} from '../../commonComponents/Loader/loader.actions';
import CONFIG from '../../config/config';
import {
  countryRegion,
  isMobile,
  loadScript,
} from '../../utils/commonMethods';
import PackageJson from '../../../package.json';
import {INDIA} from '../../utils/constants';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import Colors from '../../assets/Color/Colors';
import {globalImport} from '../../common/globalImports';
import {mobilesignInReact} from './childComponents/googleSignIn';
import FastImage from '../../common/FastImage';
import {login_desktop} from '../../utils/images';
import i18n from '../../locale/i18';
import WPStatus from './childComponents/wpStatus';
import {GlobalScreens} from '../../utils/globalConstant';
import PartnerLogin from './childComponents/PartnerLogin';
import CommonModal from '../../commonComponents/commonModal';
import {setShowLoginModal, setLoggingIn} from './redux/login.action';

const defaultCountry = {
  name: {
    en: 'India',
  },
  dial_code: '+91',
  code: 'IN',
  flag: '🇮🇳',
};

const Login = ({
  navigation,
  registerUser,
  isSendOtpSuccess,
  verifyOTP,
  verifyOtpSuccess,
  profileData,
  setLoginVisibility,
  registerUserModalClose,
  registerUserInterim,
  verifyUserInterim,
  getUserProfile,
  setIsLogin,
  showLoader,
}) => {
  const dispatch = useDispatch();
  const showLoginModal = useSelector(state => state.login.showLoginModal);
  const modalParams = useSelector(state => state.login.modalParams);
  
  const isFromClub = modalParams?.isFromClub;
  const isOtpLess = modalParams?.isOtpLess || (modalParams?.sId ? true : false);
  const sid = modalParams?.sId;
  const couponCode = modalParams?.coupon;
  const isShowConsent = modalParams?.showConsent;
  
  const insets = useSafeAreaInsets();
  const [mobileNo, setMobileNo] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [mode, setMode] = React.useState(isOtpLess ? 'otpless' : 'login');
  const [error, setError] = useState('');
  const [promo, setPromo] = useState('');
  const [showConsentForm, setShowConsentForm] = useState(
    isShowConsent ? true : false,
  );
  const [isWhatsappUpdate, setWhatsappUpdate] = useState(true);
  const [emailLogin, setEmailLogin] = React.useState(false);
  const [country, setCountry] = useState(defaultCountry);
  const selectedSource = useRef('sms');

  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const { toast } = useToast();

  useEffect(() => {
    abc();
  }, [profileData, verifyOtpSuccess]);

  async function abc() {
    console.log('profileData', profileData);
    if (profileData && profileData?.token) {
      if (profileData['first_time_login']) {
        // trackAppsflyerEvent("new_account", {
        //   status: "success",
        //   datetime: new Date(),
        //   method: "",
        // });
        // trackMoengageEvent("first_time_login", {
        //   version: parseInt(PackageJson.version, 10),
        // });
      }
      if (!globalImport.isWeb) {
        await AsyncStorage.setItem('CTProfileSet', 'true');
      }

      headerSet(profileData.token);
      if (!profileData.ageconsent && !GlobalScreens.Account.partnerLogin) {
        setShowConsentForm(true);
      } else {
        try {
          if (globalImport.isWeb) {
            console.log('profileData.token', profileData.token);
            localStorage.setItem('token', profileData.token);
          } else {
            await AsyncStorage.setItem('token', profileData.token);
          }
          if (!globalImport.isWeb) {
            await AsyncStorage.setItem('userMobNumber', mobileNo);
            await AsyncStorage.setItem(
              'userProfile',
              JSON.stringify(profileData),
            );
          } else {
            localStorage.setItem('userProfile',  JSON.stringify(profileData))
          }

          if (profileData?.preferred_locale) {
            if (globalImport.isWeb) {
              localStorage.setItem('lang', profileData?.preferred_locale);
            } else {
              await AsyncStorage.setItem('lang', profileData?.preferred_locale);
            }
            await i18n.changeLanguage(profileData?.preferred_locale);
          }
        } catch (error) {
          // Error s aving data
          console.log("PROFILE ABC ERROR", error)
        }

        // Update global state and fetch necessary data
        dispatch(getConfig());
        dispatch(getUser(true));
        dispatch(fetchLivePorfolio());
        
        // Set login state before closing modal
        setIsLogin(true);
        
        // Close modal and reset states
        onCloseBtnClick();
        
        // if (isFromClub) {
        //   navigation.pop();
        // } else {
        //   setTimeout(() => {
        //     navigation.navigate('Home', {
        //       screen: 'Markets',
        //       params: {
        //         isFirstLogin: false,
        //         isLoadProbe: {...{isrefersh: true}},
        //       },
        //     });
        //   }, 0);
        // }
      }
    }
  }

  const signInWeb = async response => {
    try {
      mobilesignInReact(response, profileSet, getUserProfile);
    } catch(e) {
      console.log(e);
    }
    
  };

  const resCallback = () => {};

  const profileSet = data => {
    dispatch(setProfileEmpty(data));
  };

  useEffect(() => {
    if (couponCode && couponCode !== "undefined" && couponCode !== "null") {
      localStorage.setItem('couponCode', couponCode);
    }
    // trackMoengageEvent('signup_click', {
    //   version: parseInt(PackageJson.version, 10),
    // });
    return () => {
      setMode('login');
      verifyUserInterim();
      registerUserInterim(false);
      registerUserModalClose();
      localStorage.removeItem('couponCode');
    };
  }, []);

  const closeModal = () => {
    //setMode('login');
    setIsLogin(true);
    // setLoginVisibility(false);
    // setModalIsOpen(false);
    //registerUserModalClose();
    //verifyUserInterim();
    //registerUserInterim(false);
  };

  useEffect(() => {
    if (
      isSendOtpSuccess &&
      isSendOtpSuccess?.success &&
      mode !== 'otp' &&
      isSendOtpSuccess?.verified !== false
    ) {
      setMode('otp');
      setError('');
      registerUserInterim(false); //changing sendotp response to false
    }
  }, [isSendOtpSuccess, mode]);

  useEffect(() => {
    if (verifyOtpSuccess && verifyOtpSuccess?.verified && mode !== 'login') {
      // trackMoengageEvent('verifyOtpSuccessCustId', {
      //   mobileNo: mobileNo,
      //   datetime: new Date(),
      // });
      getUserProfile(
        mobileNo,
        promo,
        country,
        isWhatsappUpdate,
        null,
        emailLogin ? email : null,
      );
    }
  }, [verifyOtpSuccess]);

  const onLoginSubmit = (inputData, isResendCode = false, source) => {
    if (source) {
      selectedSource.current = source;
    }

    showLoader();
    if (source) {
      selectedSource.current = source;
    }
    if (isResendCode) {
      registerUser(
        mobileNo,
        selectedSource.current,
        country?.dial_code,
        emailLogin ? email : null,
      );
    } else if (mode === 'login') {
      if (emailLogin) {
        setEmail(inputData);
      } else {
        setMobileNo(inputData);
      }
      registerUser(
        inputData,
        selectedSource.current,
        country?.dial_code,
        emailLogin ? inputData : null,
      );
      // trackMoengageEvent('loginClickedCustId', {
      //   mobileNo: inputData,
      //   datetime: new Date(),
      // });
    } else if (mode === 'otp') {
      let requestOtpData;
      if (emailLogin) {
        requestOtpData = {
          email: email,
          otp: inputData,
          whatsapp_notif: isWhatsappUpdate,
        };
      } else {
        requestOtpData = {
          mobile: mobileNo,
          otp: inputData,
          country_code: country?.dial_code,
          signup_country: country?.code,
          whatsapp_notif: isWhatsappUpdate,
        };
      }
      if (promo) {
        requestOtpData = {...requestOtpData, coupon: promo};
      }

      verifyOTP(requestOtpData, emailLogin ? email : null);
    }
  };

  const onFinalFormAccept = async (status, lang, profile) => {
    if (status) {
      const formData = new FormData();
      formData.append('ageconsent', 'true');
      if (profile?.displayname) {
        formData.append('displayname', profile.displayname);
      }
      if (profile?.country) {
        formData.append('signup_country', profile.country);
      }
      if (profile?.referral_code) {
        formData.append('referral_code', profile.referral_code);
      }
      if (lang) {
        formData.append('preferred_locale', lang);
      }
      if(profile?.dob) {
        formData.append('dob', profile.dob);
      }

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          type: 'formData',
        },
      };

      try {
        const res = await Network.updateUserDetails(formData, config);
        if (res?.data?.success) {
          try {
            await AsyncStorage.setItem('token', profileData.token);
            await AsyncStorage.setItem('userMobNumber', profileData?.mobile);
            await AsyncStorage.setItem('userProfile', JSON.stringify(profileData));
          } catch (error) {
            // Error saving data
          }
          
          // Update global state and fetch necessary data
          dispatch(getConfig());
          dispatch(getUser(true));
          dispatch(fetchLivePorfolio());
          
          // Set login state before closing modal
          setIsLogin(true);
          
          // Close modal and reset states
          onCloseBtnClick();
          
          if (isFromClub) {
            navigation.pop();
          } else {
            dispatch(setFirstLogin(true));
            setTimeout(() => {
              navigation.navigate('Home', {
                screen: 'Markets',
                params: {
                  isFirstLogin: true,
                  isLoadProbe: {...{isrefersh: true}},
                },
              });
            }, 0);
          }
        } else {
          const error = res?.data?.error || 'Error';
          showError(error);
        }
      } catch (error) {
        showError('Something went wrong. Please try again.');
      }
    } else {
      onCloseBtnClick();
    }
  };

  const onPromoSuccessSet = useCallback(promo => {
    setPromo(promo);
  }, []);

  const isIndia = globalConfigData?.loginOptions?.region === 'INDIA';

  const onBackBtnPress = () => {
    if (mode === 'login') {
      navigation.pop();
    } else {
      navigation.pop();
    }
  };

  const onModalClose = () => {
    onCloseBtnClick();
  };

  const onCloseBtnClick = () => {
    // Reset all states to initial values
    setMode('login');
    setMobileNo('');
    setEmail('');
    setError('');
    setPromo('');
    setShowConsentForm(false);
    setWhatsappUpdate(true);
    setEmailLogin(false);
    setCountry(defaultCountry);
    selectedSource.current = 'sms';
    
    // Close the modal
    dispatch(setShowLoginModal(false));
  };

  const showError = (error) => {
    toast({
      title: error,
      variant: 'destructive',
    });
  };

  return (
    <CommonModal
      showModal={showLoginModal}
      onModalCallBack={onCloseBtnClick}
      customModalStyle={{
        backgroundColor: Colors.bgWhite,
        ...(isMobile() ? {
          height: '100vh',
          width: '100%',
          margin: 0,
          maxHeight: '100vh',
          borderRadius: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 0,
        } : {
          maxHeight: '90vh',
          overflow: 'auto',
          padding: 16,
        }),
      }}
      parentStyles={isMobile() ? {
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100vh',
      } : undefined}
      persistent={true}
    >
      <View style={{
        flex: 1,
        width: isMobile() ? '100%' : undefined,
        height: isMobile() ? '100%' : undefined,
        padding: isMobile() ? 16 : 0,
      }}>
        {!showConsentForm ? (
          <View style={{
            flex: 1,
            width: isMobile() ? '100%' : undefined,
            height: isMobile() ? '100%' : undefined,
          }}>
            <LoginHeader
              onCloseBtnClick={onCloseBtnClick}
              mode={mode}
              mobileNo={emailLogin ? email : mobileNo}
              isIndia={false}
              emailLogin={emailLogin}
              isModal={true}
              isMobile={isMobile()}
            />
            {mode === 'login' ? (
              <MobileLogin
                isWhatsappUpdate={isWhatsappUpdate}
                setWhatsappUpdate={setWhatsappUpdate}
                onLoginSubmit={onLoginSubmit}
                onPromoSuccessSet={onPromoSuccessSet}
                setCountry={setCountry}
                country={country}
                mobileSigninReact={signInWeb}
                setMode={setMode}
                isIndia={isIndia}
                emailLogin={emailLogin}
                setEmailLogin={setEmailLogin}
              />
            ) : mode === 'otp' ? (
              <VerifyOtp
                onOTPSubmit={onLoginSubmit}
                registerUserInterim={registerUserInterim}
                emailLogin={emailLogin}
                mobileNo={emailLogin ? email : mobileNo}
              />
            ) : (
              <WPStatus navigation={navigation} sid={sid} />
            )}
          </View>
        ) : (
          <ConsentForm
            showLocaleSelection={profileData?.show_locale_selection}
            onFinalFormAccept={onFinalFormAccept}
            country={profileData?.country}
          />
        )}
      </View>
    </CommonModal>
  );
};

const mapStateToProps = ({login, profile}) => ({
  isSendOtpSuccess: login.interimRegisterSuccess,
  verifyOtpSuccess: login.verifyOtp_success,
  profileData: profile.profileData,
  isLoggingIn: login.isLoggingIn,
});

const mapDispatchToProps = {
  registerUser,
  verifyOTP,
  setLoginVisibility,
  registerUserModalClose,
  registerUserInterim,
  verifyUserInterim,
  getUserProfile,
  setIsLogin,
  setLoggingIn,
  showLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
